import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { CustomDateInput } from '../../Helper/InputBase';
import { CalculationUtils, formatter, validate } from '../../../utility';
import { restartIcon, appliedRuleIcon } from '../../../assets/images';
import GeneralUtils from '../../../utility/GeneralUtils';
import moment from 'moment';

class StepTwo extends Component {
  state = {
    selectedRentIncreaseDate: '',

    errors: {
      selectedRentIncreaseDate: null
    },
  }

  componentDidMount() {
    const { stepTwoData } = this.props;
    
    if (Object.keys(stepTwoData).length === 0) return;
    this.setState({
      selectedRentIncreaseDate: stepTwoData.selectedRentIncreaseDate || ''
    });
  }

  handleDateChange = (value, event) => {
    const { name } = event;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: '' },
    })
  }

  modifyClicked = () => {
    this.props.setStepTwoStatus(false);
  }

  calculateCpiYear = () => {
    const { selectedRentIncreaseDate } = this.state;
    const { stepOneData } = this.props;
    const calcRentIncreaseCausedLoss = stepOneData.calcRentIncreaseCausedLoss;
    const calcRentIncreaseServiceTimeIsAvailable = stepOneData.calcRentIncreaseServiceTimeIsAvailable;
    const calcMissedRentIncreaseDate = stepOneData.calcMissedRentIncreaseDate;

    if (selectedRentIncreaseDate) {
      return moment(selectedRentIncreaseDate).format('YYYY');
    } else if (calcRentIncreaseCausedLoss || !calcRentIncreaseServiceTimeIsAvailable) {
      return moment(calcMissedRentIncreaseDate).format('YYYY');
    }
  }

  submitStepTwo = () => {
    const { selectedRentIncreaseDate } = this.state;
    const { stepOneData } = this.props;

    const calcRentIncreaseCausedLoss = stepOneData.calcRentIncreaseCausedLoss;
    const calcRentIncreaseServiceTimeIsAvailable = stepOneData.calcRentIncreaseServiceTimeIsAvailable;
    const rentIncreaseDateRequired = !calcRentIncreaseCausedLoss && calcRentIncreaseServiceTimeIsAvailable;

    const validationArray = [{
      selectedRentIncreaseDate,
      validationRules: [
        rentIncreaseDateRequired ? { minDate: stepOneData.minRentIncreaseDate } : {},
        rentIncreaseDateRequired ? { maxDate: stepOneData.maxRentIncreaseDate } : {},
        { isRequired: rentIncreaseDateRequired, errorMsg: 'Date is required' }
      ]
    }];

    let err = validate(validationArray);
    console.log('err: ', err);
    if (Object.keys(err).length >= 1) {
      this.setState({ errors: err });
    } else {
      this.setStepTwoVars();
      this.props.setStepTwoStatus(true);
    }
  }

  setStepTwoVars = () => {
    const { selectedRentIncreaseDate } = this.state;
    const { setStepTwoVars, cpiConfig } = this.props;

    const calcCPIYear = this.calculateCpiYear();
    const calcCPIValue = CalculationUtils.getCpiForYear(cpiConfig, calcCPIYear);
    const dateNextYearCPIAvailable = calcCPIValue ? null : `Sept ${moment(selectedRentIncreaseDate).subtract(1, 'year').format('YYYY')}`;

    const stepTwoVars = {
      selectedRentIncreaseDate,
      calcCPIYear,
      calcCPIValue,
      dateNextYearCPIAvailable
    }

    const logCalcCPI = calcCPIValue ? `calcCPIValue: year: ${calcCPIValue.year}, value: ${calcCPIValue.value}` : null;

    GeneralUtils.log('----- PRINTING ALL STEP 2 VARIABLES -----', 'success');
    GeneralUtils.log(`
      selectedRentIncreaseDate: ${formatter.toDateDisplay(selectedRentIncreaseDate)}\n
      calcCPIYear: ${calcCPIYear}\n
      calcCPIValue: ${logCalcCPI}\n
      dateNextYearCPIAvailable: ${dateNextYearCPIAvailable}
    `, 'start');

    setStepTwoVars(stepTwoVars);
  }

  render() {
    const { errors, selectedRentIncreaseDate } = this.state;
    const { submitted, stepOneData, cpiConfig } = this.props;

    const minRentIncreaseDate = stepOneData.minRentIncreaseDate
    const maxRentIncreaseDate = stepOneData.maxRentIncreaseDate;
    const calcRentIncreaseCausedLoss = stepOneData.calcRentIncreaseCausedLoss;
    const calcRentIncreaseServiceTimeIsAvailable = stepOneData.calcRentIncreaseServiceTimeIsAvailable;

    const oneYearAfterLastRentIncreaseDate = stepOneData.oneYearAfterLastRentIncreaseDate;

    const renderButtons = () => {
      if (calcRentIncreaseCausedLoss || !calcRentIncreaseServiceTimeIsAvailable) {
        if (!submitted) this.submitStepTwo();
        return;
      }

      const renderModifyButton = () => submitted ? <span className="w1-step-one__modify" onClick={() => this.modifyClicked()}><img src={restartIcon} alt=""/> Modify</span> : null;
      
      return (
        <div className="w1-step-one__buttons hide-print">
        <Button variant="primary" className="step1-continue" onClick={() => this.submitStepTwo()} disabled={submitted}>Continue</Button>
        {renderModifyButton()}
      </div>
      );
    }

    const renderRentIncreaseDate = () => {
      if (calcRentIncreaseCausedLoss || !calcRentIncreaseServiceTimeIsAvailable) return;

      return (
        <div className="w1-step-two__increase-date">
          <CustomDateInput
            name='selectedRentIncreaseDate'
            disabled={submitted}
            value={selectedRentIncreaseDate}
            errors={errors.selectedRentIncreaseDate}
            cssClass='fri-questions__existing-notice'
            minDate={minRentIncreaseDate}
            maxDate={maxRentIncreaseDate}
            label={`On what date between ${formatter.toDateDisplay(minRentIncreaseDate)} and ${formatter.toDateDisplay(maxRentIncreaseDate)} do you plan to have your tenant start paying the Phase 1 additional rent increase? <br/>
            Note: The earliest date you can select is determined by the timing and notice requirements for rent increases under the Act (i.e. notice must be provided at least 3 months + 1 day in advance of the effective date of the rent increase).`}
            handleChange={this.handleDateChange}
          />
        </div>
      )
    }

    const renderCpiUnavailableError = () => {
      const calcCPIYear = this.calculateCpiYear();
      const calcCPIValue = CalculationUtils.getCpiForYear(cpiConfig, calcCPIYear);
      const dateNextYearCPIAvailable = calcCPIValue ? null : `Sept ${moment(selectedRentIncreaseDate).subtract(1, 'year').format('YYYY')}`;

      if (!calcCPIValue && submitted) {
        return (
          <p className="w1-step-two__alert alert-error">
            <b>Rate of future annual allowable rent increase not known</b> This future rent increase cannot be calculated until the maximum annual allowable rent increase rate is known for the year beginning on {formatter.toDateDisplay(moment(selectedRentIncreaseDate).format('YYYY'))}. This tool is updated each September with the annual allowable rent increase rates for the following calendar year. 
            Based on the date you have selected for this rent increase, you can return to this site and calculate this rent increase in {dateNextYearCPIAvailable}.
          </p>
          );
      } else {
        return;
      }
    }

    return (
      <div className="w1-step-two">
        <p className="w1-step-two__rule">
          <img className="w1-step-two__rule__icon" src={appliedRuleIcon} alt='' />
          <span>
            <b>Applied Rule</b>: The first additional rent increase can only be imposed 3 full months after the decision date, to allow for service of the notice of additional rent increase ({(formatter.toDateDisplay(stepOneData.earliestDecisionServiceDate))}) 
            or a minimum 1 year after the last rent increase, allowing for 3 full months from the decision date for service of the notice {isNaN(oneYearAfterLastRentIncreaseDate) || !oneYearAfterLastRentIncreaseDate ? '(does not apply)' : `(${formatter.toDateDisplay(oneYearAfterLastRentIncreaseDate)})`}. <span className="w1-step-two__rule--success">The earliest date allowed for this additional rent increase to take effect is <b> {formatter.toDateDisplay(minRentIncreaseDate)}</b> </span>
          </span>
        </p>
  
        <p className="w1-step-two__rule">
          <img className="w1-step-two__rule__icon" src={appliedRuleIcon} alt='' />
          <span>
            <b>Applied Rule</b>: The first additional rent increase must be imposed within 1 year of the earliest available additional rent increase date. <span className="w1-step-two__rule--error"> The last month for this additional rent increase to be effective is <b>{formatter.toDateDisplay(maxRentIncreaseDate, { noDay: true })}</b>. 
            If the Phase 1 additional rent increase is not imposed by this month, the full eligible amount for the first year becomes an unused portion and cannot be carried forward to the next phase or any future rent increase.</span>
          </span>
        </p>
        
        {renderRentIncreaseDate()}
        {renderButtons()}
        {renderCpiUnavailableError()}
      </div>
    );
  }
}

export default StepTwo;